define('controllers/survey',['require'],function(require) {
	return function() {
		var SurveyId = requestQueryString("s"),
					PreviewId = requestQueryString("p"),
					msg = $("#msg");

		$(".btnAnswer").on("click", function () {
			var $this = $(this),
				AllowSkip = $this.attr("data-AllowSkip"),
				dataTemplate = "PreviewId={0}&SurveyId={1}&{2}",
				questionForm = $this.parent(),
				data = dataTemplate.format(PreviewId, SurveyId, $("input, select, textarea", questionForm).serialize());

			if (AllowSkip == "True" || $("input[name*='AnswerIds']:checked", questionForm).length > 0) {
				$.post("Survey_AJAX.aspx", data, function (response) {
					Utilities.handleAJAXResponse(response,
					function (obj) {
						//success...
					},
					function (error) {
						Utilities.setError(error, msg);
					});
				});
				questionForm.hide().next().show();
				msg.hide();
			} else {
				Utilities.setError("Please answer the question.", msg);
			}
		});

		$(".btnPrev").on("click", function () {
			$(this).parent().hide().prev().show();
			msg.hide();
		});
	};
});
